import React from 'react'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'
import * as defaultConst from '../../constants/default_constants'
import DateField from 'react-mobx-admin/components/common/field/date'
import DateInput from '../input/date'
import EmbededEntityInput from '../input/embedded_entity'
import RegionsInput from '../input/regions'
import SelectInput from '../input/select'
import TextField from 'react-mobx-admin/components/common/field/text'
import moment from 'moment'
import { Button } from 'react-bootstrap'

const PPRollsItems = ({ store, label, disabledEntityFromBatch, ...rest }) => {
  const formPPRollsItems = ({ store, state, record, updateFormField, errors }) => {
    const disabled = !store.hasRight(defaultConst.ENTNAMES.PPROLLS, 'w')
    const { stageOneRestricted, stageTwoRestricted } = store.timeRestriction.checkSubentity(store, state)
    const dateRestriction = store.timeRestriction.pprolls_items


    return (
      <div className='row'>
        {store.lastSavedSubEntity && state.lastSave && store.lastSavedSubEntity[state.lastSave] &&
          <div className='col-xs-12'>
            <Button bsStyle='primary' onClick={() => store.loadLastSavedSubentity(state)} disabled={stageOneRestricted}>
              {store.__('+ Load data from the last saved item')}
            </Button><br />&nbsp;
          </div>
        }
        <div className='col-sm-12 col-lg-6'>
          <SelectInput label={store.__('file (encoded)')} attr={'s3uploads_id'} record={record}
            onChange={updateFormField} optionsrecord={store.options} optionsattr={'pprolls_uploads'}
            valueFilterFc={i => !(i.state === 'encoded' && i.file_type === 'pprolls' && !moment().isAfter(moment(i.valid_to), 'day'))}
            disabled={disabled || stageOneRestricted}
            labelattr={i => (`${i.s3_filename} | ${i.original_filename} | ${i.regions} | ${i.lang} | #${i.id}`)} valueattr='id' errors={errors} />
          <SelectInput
            label={store.__('play position')}
            attr={'position'}
            record={record}
            onChange={updateFormField}
            labelattr='value'
            valueattr='value'
            optionsattr='playPosition'
            optionsrecord={store.options}
            disabled={disabled || stageOneRestricted}
            errors={errors} />
          <SelectInput
            label={store.__('play for')}
            attr={'use_for'}
            record={record}
            onChange={updateFormField}
            labelattr='value'
            valueattr='value'
            optionsattr='playUseFor'
            optionsrecord={store.options}
            disabled={disabled || stageOneRestricted}
            errors={errors} />
          <RegionsInput label={store.__('play in regions')} attr={'regions'}
            record={record} onChange={updateFormField}
            errors={errors} disabled={disabled || stageOneRestricted} hideCheckbox
            optionsrecord={store.options} optionsattr={'Countries'} />
          <DateInput
            label={store.__('play from date')}
            attr={'valid_from'}
            record={record}
            disabled={disabled || stageOneRestricted}
            minDate={dateRestriction.valid_from.minDate}
            onChange={updateFormField}
            errors={errors} />
          <DateInput
            label={store.__('play to date')}
            attr={'valid_to'}
            disabled={disabled || stageTwoRestricted}
            minDate={dateRestriction.valid_to.minDate}
            record={record}
            onChange={updateFormField}
            errors={errors} />
        </div>
      </div>
    )
  }

  const attr = 'pprolls_items'
  return (
    <EmbededEntityInput {...rest}
      disabled={!!disabledEntityFromBatch}
      attr={attr}
      store={store}
      items={store.cv.record.get(attr)}
      label={label || store.__('Asset items')}
      add_title={store.__('Add item')}
      edit_title={store.__('Edit item')}
      errors={store.cv.errors}
      fields={[
        (attr, row) => (<TextField attr={attr} val={row[attr]} />),
        (attr, row) => {
          const component = ({ text }) => {
            const i = store.options.has('pprolls_uploads') && store.options.get('pprolls_uploads').find(i => i.id === parseInt(text))
            return i ? `${i.s3_filename} | ${i.original_filename} | ${i.regions} | ${i.lang} | #${i.id}` : text
          }
          return <TextField attr={attr} val={row[attr]} Component={component} />
        },
        (attr, row) => (<TextField attr={attr} val={row[attr]} />),
        (attr, row) => (<TextField attr={attr} val={row[attr]} />),
        (attr, row) => (<TextField attr={attr} val={row[attr]} />),
        (attr, row) => (<DateField attr={attr} val={row[attr]} valN={row.valid_to} />),
        (attr, row) => (<DateField attr={attr} val={row[attr]} valN={row.valid_from} />)
      ]}
      rowId={(row) => null}
      EditForm={formPPRollsItems}
    />
  )
}

PPRollsItems.propTypes = {
  store: PropTypes.object.isRequired
}

export default observer(PPRollsItems)
